import { storage } from "@/src/common/services/storage.service";

const ACCESS_TOKEN_KEY = "storyline.access_token";
const REFRESH_TOKEN_KEY = "storyline.refresh_token";

export const getAccessToken = (): Promise<string | null> => storage.getItem(ACCESS_TOKEN_KEY);

export const getRefreshToken = (): Promise<string | null> => storage.getItem(REFRESH_TOKEN_KEY);

export const setTokens = async ({ accessToken, refreshToken }: { accessToken: string; refreshToken: string }): Promise<void> => {
	await Promise.all([storage.setItem(ACCESS_TOKEN_KEY, accessToken), storage.setItem(REFRESH_TOKEN_KEY, refreshToken)]);
};

export const clearTokens = async (): Promise<void> => {
	await Promise.all([storage.removeItem(ACCESS_TOKEN_KEY), storage.removeItem(REFRESH_TOKEN_KEY)]);
};
